import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { TagInputDTO, TagOutputDTO } from 'src/services/reservation/tag/tagDTO'
class TagServices {
  async createAndAssociateToitem(item_id: number, body: TagInputDTO): Promise<TagOutputDTO> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/tag/item/`, body, {
        params: { item_id },
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTagsWithParams(params: any): Promise<TagOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/tag/`, {
        params: params,
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTagsByWorkUnit(workUnitId: number): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/tag/work_unit_id/${workUnitId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const tagServices = new TagServices()
